import * as R from 'ramda';

import { MultiMetricOptionMixin } from '../mixin';
import metricTranslatorMixin from '@/mixins/translator/metric';

import ChipList from '../../components/ChipList';
import Chip from '../../components/Chip';

import * as C from '../../options/styles';

import MetricIcon from '@svgIcons/dashboard/metric.svg';

import { isValueExist, changeOrder } from '@util';
import { IFRAME_EVENT_MESSAGE, WIDGET_TYPES } from '@consts';
import { makeMetricFormat, FIELD_KEY } from '../utils';
import { MAX_CREATIVE_METRIC_COUNT, MAX_GRAPH_METRIC_COUNT } from '../consts';

export default {
    name: 'MultiMetricOption',
    mixins: [MultiMetricOptionMixin, metricTranslatorMixin],
    props: {
        panelKey: String,
        currentList: {
            type: Array,
            default() {
                return [];
            },
        },
        canEditCustomMetric: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            iframeListeners_: [
                {
                    eventType: IFRAME_EVENT_MESSAGE.UPDATE_METRIC_PANEL,
                    listener: (e) => {
                        const { data } = e;
                        if (!data || data.panelKey !== this.panelKey) return;
                        const { selectedFields } = data;

                        const updated = R.compose(
                            R.uniqBy(R.prop(FIELD_KEY)),
                            R.map(makeMetricFormat)
                        )(selectedFields);
                        this.$emit('update', updated);
                    },
                },
            ],
        };
    },
    computed: {
        title() {
            return this.$t('FIELD_PANEL.metric.second_panel_title');
        },
        mainGuide() {
            return this.$t('FIELD_PANEL.metric.second_panel_main_guide');
        },
        subGuide() {
            return this.$t('FIELD_PANEL.metric.second_panel_sub_guide');
        },
        limitCount() {
            let limitCount;

            switch (this.widgetType) {
                case WIDGET_TYPES.GRAPH:
                    limitCount = MAX_GRAPH_METRIC_COUNT;
                    break;
                case WIDGET_TYPES.CREATIVE:
                    limitCount = MAX_CREATIVE_METRIC_COUNT;
                    break;
            }
            return limitCount;
        },
    },
    methods: {
        reorderItems({ oldIndex, newIndex }) {
            const updated = changeOrder({
                oldIndex,
                newIndex,
                value: this.currentList,
            });
            this.$emit('update', updated);
        },
        removeItem(item) {
            const targetKey = item[FIELD_KEY];
            const updated = R.filter(
                R.complement(R.propEq(FIELD_KEY, targetKey))
            )(this.currentList);
            this.$emit('update', updated);
        },
        renderItem() {
            const { cursor, renderNoList, currentList, disabled } = this;

            return (
                <C.ItemWrapper class="item-wrapper">
                    {isValueExist(currentList) ? (
                        <ChipList
                            disabled={disabled}
                            value={currentList}
                            onReorder={this.reorderItems}
                        >
                            {currentList.map((item) => {
                                const displayName =
                                    this.getFieldName(item) ??
                                    this.getMetricName(item);
                                const status = this.getFieldStatus(item);
                                const isInvalid =
                                    status === C.ITEM_STATUS.INVALID;

                                return this.wrapTooltip({
                                    visible: isInvalid,
                                    title: this.$t(
                                        'EDITABLE_DASHBOARD.metric_no_longer_valid'
                                    ),
                                    content: (
                                        <Chip
                                            title={displayName}
                                            status={status}
                                            loading={this.fieldLabelsLoading}
                                            dragCursor={cursor}
                                            sortable
                                            removable
                                            onRemove={() => {
                                                this.removeItem(item);
                                            }}
                                        />
                                    ),
                                });
                            })}
                        </ChipList>
                    ) : (
                        renderNoList(
                            this.$t('EDITABLE_DASHBOARD.list_empty_metric')
                        )
                    )}
                </C.ItemWrapper>
            );
        },
    },
    render() {
        const { wrapOptions, renderItem } = this;

        return (
            <C.ComponentWrapper>
                {wrapOptions({
                    children: renderItem(),
                    title: this.$t('NEW_DASHBOARD.order_of_columns'),
                    icon: <MetricIcon class="metric-icon" />,
                    loading: this.fieldLabelsLoading,
                })}
            </C.ComponentWrapper>
        );
    },
};
